export default "__VITE_ASSET__BAdMk7b1__"